<template>
    <v-card>
        <v-card-title>Telsasoft Dashboard Management</v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <div class="config-tables-container">
                <v-row>
                    <v-col cols="12">
                        <span class="config-table-label">Dashboard Library</span>
                        <v-simple-table class="config-table" height="275px" fixed-header>
                            <thead>
                                <tr>
                                    <th class="text-left">Name</th>
                                    <th class="text-left">Owner</th>
                                    <th class="text-left">Device Type</th>
                                    <th class="text-left">Private/Public</th>
                                    <th class="text-left">Favorite</th>
                                    <th class="text-left">Default</th>
                                    <th class="text-center"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="cursor: pointer" v-for="dashboard in $props.dashboards" :key="dashboard.dashboard_name" @click="selectDashboard(dashboard)">
                                    <td>{{ dashboard.dashboard_name }}</td>
                                    <td>{{ usernameLookup(dashboard.user_id) }}</td>
                                    <td><v-icon>{{ getDeviceTypeIcon(dashboard.dashboard_device_type) }}</v-icon></td>

                                    <td>
                                        <v-switch class="public-switch" color="#c42111" :ripple="true" v-model="dashboard.dashboard_public" :disabled="dashboard.user_id != $store.state.user.user_id" @click.native.capture.stop="publicClick(dashboard)">
                                            <template v-slot:label>
                                                <label>
                                                    {{ dashboard.dashboard_public ? 'public' : 'private' }}
                                                </label>
                                            </template>
                                        </v-switch>
                                    </td>
                                    <td>
                                        <v-btn icon @click.stop="favClick(dashboard)">
                                            <v-icon la class="favorite-star" color="#ffffff" v-if="!dashboard.fav">mdi-star-outline</v-icon>
                                            <v-icon class="favorite-star" color="yellow" v-if="dashboard.fav">mdi-star</v-icon>
                                        </v-btn>
                                    </td>
                                    <td>
                                        <v-checkbox class="default-checkbox" color="#c42111" v-model="dashboard.default" @click.stop="defaultClick(dashboard)" />
                                    </td>
                                    <td>
                                        <v-btn icon color="#DC3545" :disabled="dashboard.user_id != $store.state.user.user_id" @click.stop="deleteDashboardClick(dashboard)"><v-icon la>mdi-delete-forever</v-icon></v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>

                </v-row>
            </div>

            <v-divider class="mt-2 mb-4" />

            <span class="selected-config-title">Selected Dashboard</span>
            <div class="config-details-container">
                <div v-if="selectedDashboard">
                    <div class="config-name">
                        <v-form ref="dashboardNameForm" v-model="dashboardNameFormValid" :lazy-validation="true">
                            <v-text-field v-model="selectedDashboardClone.dashboard_name" :label="`Dashboard Name`" color="#c42111" :disabled="!userOwnsSelectedDashboard" :rules="[validation.required(selectedDashboardClone.dashboard_name, 'Dashboard Name'), validation.unique(selectedDashboardClone.dashboard_name, $props.dashboards, $store.state.user.user_id)]">
                                <template v-slot:append>
                                    <v-btn color="#4caf50" icon @click="saveDashboardNameClick"><v-icon>mdi-content-save</v-icon></v-btn>
                                </template>
                            </v-text-field>
                        </v-form>
                    </div>

                    <div class="column-details">
                        <v-icon class="icon">mdi-google-maps</v-icon>
                        <span class="label">Map Widgets</span>
                        <span class="value">{{ mapsWidgetsCount }}</span>
                    </div>
                    <div class="column-details">
                        <v-icon class="icon">mdi-bell-ring</v-icon>
                        <span class="label">Alarm Widgets</span>
                        <span class="value">{{ alarmWidgetsCount }}</span>
                    </div>
                    <div class="column-details">
                        <v-icon class="icon">mdi-sticker-alert</v-icon>
                        <span class="label">Issue Widgets</span>
                        <span class="value">{{ issueWidgetsCount }}</span>
                    </div>
                    <div class="column-details">
                        <v-icon class="icon">mdi-chart-bar</v-icon>
                        <span class="label">Report Widgets</span>
                        <span class="value">{{ reportWidgetsCount }}</span>
                    </div>
                    <div class="column-details last">
                        <v-icon class="icon">mdi-cloud</v-icon>
                        <span class="label">Tableau Widgets</span>
                        <span class="value">{{ tableauWidgetsCount }}</span>
                    </div>

                    <div class="button-container">
                        <v-btn class="ml-3 mt-4" color="#c42111" @click="openDashboardClick">Open</v-btn>
                    </div>
                </div>

                <div v-if="!selectedDashboard">
                    <span class="no-dashboard-selected-text">Select a dashboard from the libray</span>
                </div>
            </div>
            
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('close')">Close</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'DashboardManagement',
    props: ['dashboards'],
    components: {

    },
    data: () => ({
        dashboardNameFormValid: true,
        selectedDashboard: null,
        selectedDashboardClone: null,
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            unique: (value, dashboards, userId) => (!value || !dashboards.some(d => {return (d.user_id == userId && d.dashboard_name == value.trim())})) || 'This Dashboard Name is already is use for this user. '
        }
    }),

    computed: {
        mapsWidgetsCount: function() {
            let count = 0;
            for(let widget of this.selectedDashboard.dashboard_config.widgets) {
                if(widget.type == 'geomap') {
                    count++;
                }
            }
            return count;
        },
        alarmWidgetsCount: function() {
            let count = 0;
            for(let widget of this.selectedDashboard.dashboard_config.widgets) {
                if(widget.type == 'alarms') {
                    count++;
                }
            }
            return count;
        },
        issueWidgetsCount: function() {
            let count = 0;
            for(let widget of this.selectedDashboard.dashboard_config.widgets) {
                if(widget.type == 'issues') {
                    count++;
                }
            }
            return count;
        },
        reportWidgetsCount: function() {
            let count = 0;
            for(let widget of this.selectedDashboard.dashboard_config.widgets) {
                if(widget.type == 'report') {
                    count++;
                }
            }
            return count;
        },
        tableauWidgetsCount: function() {
            let count = 0;
            for(let widget of this.selectedDashboard.dashboard_config.widgets) {
                if(widget.type == 'tableau') {
                    count++;
                }
            }
            return count;
        },

        userOwnsSelectedDashboard: function() {
            if(!this.selectedDashboard) {
                return false;
            }
            return this.selectedDashboard.user_id == this.$store.state.user.user_id;
        },
    },

    methods: {
        selectDashboard: function(dashboard) {
            this.selectedDashboard = dashboard;
            this.selectedDashboardClone = JSON.parse(JSON.stringify(dashboard));
        },

        publicClick: function(dashboard) {
            // Warn them if they are making a public dashboard private.
            if(dashboard.dashboard_public) {
                this.$store.commit('showConfirmModal', {
                    title: 'Confirm Overwrite',
                    message: `Making this dashboard private will prevent other users from continuing to use it. Are you sure you want to do this?`,
                    type: 'warning',
                    hideCancel: false,
                    confirmAction: () => {dashboard.dashboard_public = false; this.saveDashboard(dashboard);}
                });
            }
            else {
                dashboard.dashboard_public = true;
                this.saveDashboard(dashboard);
            }
        },

        favClick: function(dashboard) {
            dashboard.fav = !dashboard.fav;
            dashboard.default = dashboard.fav ? dashboard.default : false;
            this.saveDashboardFavs();
        },

        defaultClick: function(dashboard) {
            let newVal = dashboard.default;
            this.$props.dashboards.forEach(d => {
                d.default = false;
            });
            dashboard.default = newVal;
            dashboard.fav = dashboard.default ? true : dashboard.fav;
            this.saveDashboardFavs();
        },

        saveDashboardFavs: function() {
            let dashboardFavs = [];
            for(let dashboard of this.dashboards) {
                if(dashboard.fav) {
                    dashboardFavs.push({
                        dashboard_id: dashboard.dashboard_id,
                        default: dashboard.default
                    });
                }
            }

            let route = `${TELSA.apiHost}dashboard/favs`;
            return this.$http.post(route, {args: {dashboard_favs: dashboardFavs}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },

        saveDashboardNameClick: function() {
            if(this.$refs.dashboardNameForm.validate()) {
                this.$store.commit('showConfirmModal', {
                    title: 'Confirm Overwrite',
                    message: `Renaming this dashboard will prevent other users from continuing to use it. Are you sure you want to do this?`,
                    type: 'warning',
                    hideCancel: false,
                    confirmAction: () => {this.saveDashboard(this.selectedDashboardClone); this.selectedDashboard.dashboard_name = this.selectedDashboardClone.dashboard_name;}
                });
            }
        },
        saveDashboard: function(dashboard) {
            TELSA.loading(true);
            let route = `${TELSA.apiHost}dashboard/edit`;
            return this.$http.post(route, {args: {dashboard: dashboard}}).then(response => {
                let result = response.body;
                this.saveDashboardFavs();
                TELSA.loading(false);
            });
        },

        deleteDashboardClick: function(dashboard) {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Delete',
                message: `Deleting this dashboard will prevent other users from continuing to use it. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteDashboard(dashboard)
            });
        },
        deleteDashboard: function(dashboard) {
            TELSA.loading(true);
            this.$props.dashboards.splice(this.$props.dashboards.indexOf(dashboard), 1);
            let route = `${TELSA.apiHost}dashboard/delete`;
            return this.$http.post(route, {args: {dashboard: dashboard}}).then(response => {
                let result = response.body;
                this.saveDashboardFavs();
                // If the dashboard we just deleted is the one we're looking at, then remove that too.
                if(dashboard == this.selectedDashboard) {
                    this.selectedDashboard = null;
                    this.selectedDashboardClone = null;
                }
                this.$emit('delete', dashboard);
                TELSA.loading(false);
            });
        },

        usernameLookup: function(userId) {
            for(let user of this.$store.state.batchConfig.users) {
                if(user.user_id == userId) {
                    return user.user_username;
                }
            }
            return '';
        },

        getDeviceTypeIcon: function(deviceType) {
            if(deviceType == 'smartphone') {
                return 'mdi-cellphone';
            }
            else if(deviceType == 'tablet') {
                return 'mdi-tablet-ipad';
            }
            else {
                return 'mdi-desktop-mac';
            }
        },

        openDashboardClick: function() {
            this.$emit('open', this.selectedDashboard);
        }
    },

    mounted() {
        
    },

    created() {
        console.log('dashboards: ', this.$props.dashboards);
    }

  
};
</script>

<style scoped>

    .config-table-label {
        display: block;
        color: #ffffff;
        font-size: 18px;
        margin-bottom: 0.5em;
    }

    .config-table {
        border-radius: 5px;
        border: gray solid 1px;
        overflow-y: auto;
    }

    .public-switch {
        margin: 0px !important;
        padding: 0px !important;
        height: 25px;
    }

    .favorite-star {
        cursor: pointer;
    }

    .default-checkbox {
        margin: 0px !important;
        padding: 0px !important;
        height: 25px;
    }

    .config-tables-container {
        margin-top: 1em;
    }

    .selected-config-title {
        display: block;
        color: #ffffff;
        font-size: 18px;
    }

    .config-details-container {
        position: relative;
        margin-top: 1em;
        border-radius: 5px;
        border: gray solid 1px;
        height: 125px;

        padding-top: 30px;
        padding-left: 40px;
    }



    .config-name {
        display: inline-block;
        margin-right: 80px;
        width: calc(100% - 950px);
        vertical-align: top;
        padding-top: 5px;
    }

    .column-details {
        display: inline-block;
        margin-right: 55px;
        position: relative;
        vertical-align: top;
        position: relative;
    }
    .column-details.last {
        margin-right: 55px;
    }
    .column-details .icon {
        position: absolute;
        bottom: -7px;
        left: -25px;
    }
    .column-details .label {
        display: block;
        font-size: 11px;
        margin-bottom: 5px;

        color: #ffffff;
    }
    .column-details .value {
        display: block;
        font-size: 42px;
        color: #ffffff;
        letter-spacing: 3px;
    }
    .column-details .action-drawer-icon {
        font-size: 55px;
        position: absolute;
        top: 10px;
        left: -5px;
        color: #ffffff;
    }
    .column-details .action-drawer-icon.inactive {
        color: rgba(128, 128, 128, 0.6);
    }

    .button-container {
        display: inline-block;
    }

    .no-dashboard-selected-text {
        margin-top: 16px;
        font-size: 32px;
        text-align: center;
        color: rgba(255, 255, 255, 0.5);
        display: block;
        margin-left: -40px;
    }



    @media(max-width: 1600px) {
        .config-details-container {
            overflow: auto;
            padding-top: 10px;
            padding-left: 20px;
        }
        .config-details-container .config-name {
            width: 150px;
            margin-right: 20px;
        }
        .config-details-container .column-details {
            margin-right: 10px;
            margin-left: 20px;
            margin-top: 15px;
        }
        .config-details-container .column-details.last {
            margin-right: 5px;
        }
        .config-details-container .column-details .value {
            font-size: 22px;
        }
        .config-details-container .column-details .icon {
            bottom: -2px;
            left: -25px;
        }
        .config-details-container .button-container {
            margin-top: 15px;
        }
        .config-details-container .button-container {
            width: 100px;
        }
        .column-details .action-drawer-icon {
            font-size: 45px;
            top: 15px;
            left: -5px;
        }
    }

    @media(max-width: 800px) {
        .config-tables-container {
            overflow-x: auto;
        }
        .config-tables-container .config-table {
            width: 800px;
        }

        .config-details-container {
            overflow: auto;
            padding-top: 10px;
            padding-left: 20px;
        }
        .config-details-container .config-name {
            width: 150px;
            margin-right: 20px;
        }
        .config-details-container .column-details {
            margin-right: 10px;
            margin-left: 20px;
            margin-top: 15px;
        }
        .column-details.last {
            margin-right: 5px;
        }
        .config-details-container .column-details .value {
            font-size: 22px;
        }
        .config-details-container .column-details .icon {
            bottom: -2px;
            left: -25px;
        }
        .config-details-container .button-container {
            margin-top: 15px;
        }
    }

</style>
